import React, { useContext, useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import colors from "assets/theme/base/colors";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDTextField from "components/MDTextField";
import ImageUploader from "components/MDImageUploader";

const DraggableLinkForm = ({
  formik,
  handleRemoveService,
  handleServiceTitleChange,
  handleServiceDescriptionChange,
  handleServicePriceChange,
  serviceProfile,
  setServiceProfile,
}) => {
  const { sideNav, modal } = colors;

  return (
    <DragDropContext>
      <Droppable droppableId="droppable-grid" direction="vertical">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps} className="react-beautiful-dnd">
            {formik.values.business_services.map((service, businessServiceIndex) => (
              <Draggable
                key={businessServiceIndex}
                draggableId={`draggable-${businessServiceIndex}`}
                index={businessServiceIndex}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    //   {...provided.dragHandleProps}
                    style={{
                      ...provided.draggableProps.style,
                      position: "static",
                      marginTop: "20px",
                    }}
                  >
                    <Grid item xs={12} md={12}>
                      <Accordion
                        sx={{
                          boxShadow:
                            "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgb(17 17 26 / 0%) 0px 8px 32px",
                        }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <MDBox
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <MDBox sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                              <MDBox
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "18px",
                                  fontWeight: "600",
                                  color: sideNav.textColor,
                                  marginTop: "3px",
                                }}
                              >
                                Products/Services {businessServiceIndex + 1}
                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontWeight: "normal",
                                    fontSize: "16px",
                                  }}
                                >
                                  {formik?.values?.business_services[businessServiceIndex]?.title
                                    ? `(${formik.values.business_services[businessServiceIndex].title})`
                                    : null}
                                </span>
                              </MDBox>
                            </MDBox>

                            <MDBox
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              {/* {formik.values.business_services.length > 1 && ( */}
                              <IconButton
                                sx={{
                                  cursor: "pointer",
                                  width: "30px",
                                  height: "30px",
                                  borderRadius: "50px",
                                  transition: "all 0.2s ease-in-out",
                                  color: `${sideNav?.textColor} !important`,
                                  "&:hover": {
                                    backgroundColor: `${modal?.btnHover} !important`,
                                    color: `${modal?.textHover} !important`,
                                  },
                                }}
                                onClick={() => handleRemoveService(businessServiceIndex)}
                              >
                                <ClearIcon
                                  sx={{
                                    padding: "3px",
                                    width: "25px",
                                    height: "25px",
                                  }}
                                />
                              </IconButton>
                              {/* )} */}
                            </MDBox>
                          </MDBox>
                        </AccordionSummary>

                        <AccordionDetails>
                          <MDBox sx={{ marginBottom: "20px" }}>
                            <ImageUploader
                              img={serviceProfile[businessServiceIndex]?.url}
                              folderName={"/business_services"}
                              name={`business_services[${businessServiceIndex}].service_image`}
                              fileName={`business_services[${businessServiceIndex}].service_image`}
                              formik={formik}
                              label="Business Service Image"
                              sx={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                marginBottom: "16px",
                              }}
                              setServiceProfile={setServiceProfile}
                              serviceProfile={serviceProfile}
                              index={businessServiceIndex}
                            />
                          </MDBox>

                          <MDBox alignItems="center" sx={{ marginBottom: "20px" }}>
                            <MDInput
                              type="text"
                              label={`Title`}
                              name={`business_services[${businessServiceIndex}].title`}
                              value={service.title}
                              onChange={(e) =>
                                handleServiceTitleChange(businessServiceIndex, e.target.value)
                              }
                              onBlur={formik.handleBlur}
                              sx={{ width: "100%" }}
                              variant="standard"
                            />
                            {/* {formik.touched.business_services[businessServiceIndex].title &&
                              formik.errors.business_services[businessServiceIndex].title && (
                                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                                  {formik.errors.business_services[businessServiceIndex].title}
                                </MDBox>
                              )} */}
                          </MDBox>

                          <MDBox alignItems="center" sx={{ marginBottom: "20px" }}>
                            <MDTextField
                              type="description"
                              label={`Description`}
                              name={`business_services[${businessServiceIndex}].description`}
                              value={service.description}
                              onChange={(e) =>
                                handleServiceDescriptionChange(businessServiceIndex, e.target.value)
                              }
                              onBlur={formik.handleBlur}
                              sx={{ width: "100%" }}
                              variant="standard"
                              className="address_textarea"
                              fullWidth
                              multiline={true}
                              rows={4}
                            />
                            {/* {formik.touched.business_services[businessServiceIndex].description &&
                              formik.errors.business_services[businessServiceIndex].description && (
                                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                                  {
                                    formik.errors.business_services[businessServiceIndex]
                                      .description
                                  }
                                </MDBox>
                              )} */}
                          </MDBox>

                          <MDBox alignItems="center">
                            <MDInput
                              type="number"
                              label={`Price`}
                              name={`business_services[${businessServiceIndex}].price`}
                              value={service.price}
                              onChange={(e) =>
                                handleServicePriceChange(businessServiceIndex, e.target.value)
                              }
                              onBlur={formik.handleBlur}
                              sx={{ width: "100%" }}
                              variant="standard"
                            />
                          </MDBox>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DraggableLinkForm;
